import { useState } from "react";
import "./s.css";

const vows = [
  {
    step: "Step 1",
    title: "Food & Nourishment",
    meaning:
      "Together we promise to provide food, health, and happiness for our family.",
  },
  {
    step: "Step 2",
    title: "Strength",
    meaning:
      "We promise to give each other physical, mental, and spiritual strength.",
  },
  {
    step: "Step 3",
    title: "Prosperity",
    meaning:
      "We will work together to earn wealth honestly and live a prosperous life.",
  },
  {
    step: "Step 4",
    title: "Love & Respect",
    meaning:
      "We promise to love, respect, trust, and support each other forever.",
  },
  {
    step: "Step 5",
    title: "Children & Family",
    meaning:
      "We pray for healthy children and promise to raise them with good values.",
  },
  {
    step: "Step 6",
    title: "Health & Longevity",
    meaning:
      "We promise to stay together through all seasons of life with good health.",
  },
  {
    step: "Step 7",
    title: "Friendship & Lifelong Bond",
    meaning:
      "With this final step, we become lifelong friends, companions, and soulmates.",
  },
];

export default function Saptapadi() {
  const [currentStep, setCurrentStep] = useState(0);

  const nextStep = () => {
    if (currentStep < vows.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="saptapadi-container">
      <h1>🔥 Saptapadi - Seven Sacred Vows 🔥</h1>

      <div className="step-card">
        <h2>{vows[currentStep].step}</h2>
        <h3>{vows[currentStep].title}</h3>
        <p>{vows[currentStep].meaning}</p>
      </div>

      <div className="progress">
        {vows.map((_, index) => (
          <div
            key={index}
            className={`circle ${index <= currentStep ? "active" : ""}`}
          >
            {index + 1}
          </div>
        ))}
      </div>

      <div className="buttons">
        <button onClick={prevStep} disabled={currentStep === 0}>
          Previous
        </button>

        <button
          onClick={nextStep}
          disabled={currentStep === vows.length - 1}
        >
          Next Step
        </button>
      </div>
    </div>
  );
}